module.exports = __webpack_public_path__ + "static/christmashome-669e339ee638b63ca088b0ed3f322061.jpeg";